export const ApiRequestHeaderTypes = {
  CONTENT_TYPE: "Content-Type",
  RESPONSE_TYPE: "responseType"
};

export const ApiRequestHeaderValueTypes = {
  MULTIPART_FORM_DATA: "multipart/form-data",
  BLOB: "blob"
};
